<template>
  <div class="vip-page">
    <!-- 顶部栏 -->
    <header class="top-nav">
      <button type="button" class="icon-btn" :aria-label="getLabel('utils.loading', 'Update')" @click="onRefresh">
        <van-icon name="replay" />
      </button>
      <h1 class="nav-title">
        <svg class="crown-svg" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M3 17.5L2 7l5 4 5-7.5L17 11l5-4-1 10.5H3z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
        </svg>
        {{ getLabel('vip.title', 'VIP Levels') }}
      </h1>
      <button type="button" class="icon-btn" aria-label="Cerrar" @click="$router.go(-1)">
        <van-icon name="cross" />
      </button>
    </header>

    <main class="page-shell">
      <!-- Nivel Actual -->
      <section class="current-card">
        <div class="current-top">
          <span class="current-label">{{ getLabel('vip.currentLevel', 'Current Level') }}</span>
          <button type="button" class="history-btn" @click="goSalaryHistory">
            <van-icon name="notes-o" />
            <span>{{ getLabel('vip.salaryHistory', 'Salary History') }}</span>
          </button>
        </div>
        <div class="current-level">
          <svg class="crown-svg lg" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 17.5L2 7l5 4 5-7.5L17 11l5-4-1 10.5H3z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
          </svg>
          {{ vipCurrent }}
        </div>
        <div class="current-divider"></div>
        <div class="current-sub">
          <van-icon name="cash-o" />
          <span>{{ getLabel('vip.subRecharge', 'Subordinate Charge Amount') }}: {{ formatMoney(vipSubRecharge) }} INR</span>
        </div>
      </section>

      <!-- Siguiente Nivel -->
      <section v-if="vipNext" class="next-section">
        <h2 class="next-title">{{ getLabel('vip.nextLevel', 'Next Level') }}: {{ vipNext.name }}</h2>
        <div class="req-grid">
          <div class="req-item" v-for="req in vipNext.items" :key="req.key">
            <div class="req-head">
              <span>{{ req.label }}</span>
              <van-icon v-if="req.ok" name="success" class="mark ok" />
              <van-icon v-else name="clear" class="mark no" />
            </div>
            <div class="req-value">{{ formatNum(req.current) }} / {{ formatNum(req.target) }}<span v-if="isMoneyReq(req.key)" class="unit"> INR</span></div>
          </div>
        </div>

        <div class="salary-card">
          <span class="salary-icon"><van-icon name="description" /></span>
          <div class="salary-mid">
            <div class="salary-label">{{ getLabel('vip.dailySalary', 'Daily Salary') }}</div>
            <div class="salary-value">{{ formatMoney(nextLevelSalary) }} INR</div>
          </div>
          <span class="per-day">/día</span>
        </div>

        <div class="ascend-tip">
          <van-icon name="info-o" />
          <span>{{ ascendTipText }}</span>
        </div>

        <button type="button" class="ascend-btn" :disabled="ascendLoading" @click="onAscend">
          <svg class="crown-svg sm" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 17.5L2 7l5 4 5-7.5L17 11l5-4-1 10.5H3z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
          </svg>
          {{ ascendLoading ? getLabel('utils.loading', 'Cargando...') : getLabel('vip.requestAscend', 'Request an Ascent') }}
        </button>
      </section>
      <!-- Beneficios del Nivel -->
      <section class="benefits">
        <h2 class="benefits-title">
          <svg class="crown-svg" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 17.5L2 7l5 4 5-7.5L17 11l5-4-1 10.5H3z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
          </svg>
          {{ getLabel('vip.benefits', 'Level Benefits') }}
        </h2>

        <div v-for="lv in levels" :key="lv.level" class="level-card">
          <div class="level-head">
            <svg class="crown-svg" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M3 17.5L2 7l5 4 5-7.5L17 11l5-4-1 10.5H3z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
            </svg>
            <span class="level-name">VIP{{ lv.level }}</span>
            <van-icon name="gold-coin-o" class="mini-crown" />
          </div>
          <div class="req-grid">
            <div class="req-item">
              <div class="req-head"><span>{{ getLabel('vip.personalRecharge', 'Personal recharge') }}</span></div>
              <div class="req-value cyan">{{ formatMoney(lv.recharge) }} INR</div>
            </div>
            <div class="req-item">
              <div class="req-head"><span>{{ getLabel('vip.directSubs', 'Direct Subordinates') }}</span></div>
              <div class="req-value cyan">{{ lv.directos }}</div>
            </div>
            <div class="req-item">
              <div class="req-head"><span>{{ getLabel('vip.teamMembers', 'Team Members') }}</span></div>
              <div class="req-value cyan">{{ lv.team }}</div>
            </div>
            <div class="req-item">
              <div class="req-head"><span>{{ lv.subLabel }}</span></div>
              <div class="req-value cyan">{{ formatMoney(lv.subRecarga) }} INR</div>
            </div>
          </div>
          <div class="salary-card">
            <span class="salary-icon"><van-icon name="description" /></span>
            <div class="salary-mid">
              <div class="salary-label">{{ getLabel('vip.dailySalary', 'Daily Salary') }}</div>
              <div class="salary-value">{{ formatMoney(lv.salary) }} INR</div>
            </div>
            <span class="per-day">/Day</span>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { Icon, Toast } from "vant";

Vue.use(Icon);
Vue.use(Toast);

// VIP 等级配置（VIP0 - VIP10）
const DEFAULT_SUB_LABEL = "Subordinate Charge Amount";
const TEAM_SUB_LABEL = "Equipment Charge Amount";
const VIP_LEVELS = [
  { level: 0,  recharge: 0,       directos: 0,  team: 0,    subRecarga: 0,       salary: 0,      subLabel: DEFAULT_SUB_LABEL },
  { level: 1,  recharge: 1000,    directos: 3,  team: 0,    subRecarga: 3000,    salary: 80,     subLabel: DEFAULT_SUB_LABEL },
  { level: 2,  recharge: 3000,    directos: 5,  team: 0,    subRecarga: 6000,    salary: 120,    subLabel: DEFAULT_SUB_LABEL },
  { level: 3,  recharge: 5000,    directos: 12, team: 0,    subRecarga: 14000,   salary: 170,    subLabel: DEFAULT_SUB_LABEL },
  { level: 4,  recharge: 10000,   directos: 26, team: 0,    subRecarga: 38000,   salary: 230,    subLabel: DEFAULT_SUB_LABEL },
  { level: 5,  recharge: 20000,   directos: 35, team: 0,    subRecarga: 110000,  salary: 320,    subLabel: DEFAULT_SUB_LABEL },
  { level: 6,  recharge: 30000,   directos: 0,  team: 160,  subRecarga: 600000,  salary: 500,    subLabel: TEAM_SUB_LABEL },
  { level: 7,  recharge: 40000,   directos: 0,  team: 300,  subRecarga: 2600000, salary: 1000,   subLabel: TEAM_SUB_LABEL },
  { level: 8,  recharge: 80000,   directos: 0,  team: 800,  subRecarga: 8000000, salary: 1700,   subLabel: TEAM_SUB_LABEL },
  { level: 9,  recharge: 120000,  directos: 0,  team: 2000, subRecarga: 0,       salary: 3500,   subLabel: DEFAULT_SUB_LABEL },
  { level: 10, recharge: 200000,  directos: 0,  team: 5000, subRecarga: 0,       salary: 7000,   subLabel: DEFAULT_SUB_LABEL },
];

export default {
  name: "vip",
  data() {
    return {
      levels: VIP_LEVELS,
      vipCurrent: "VIP0",
      vipSubRecharge: 0,
      vipNext: null,
      ascendLoading: false,
    };
  },
  computed: {
    nextLevelSalary() {
      if (!this.vipNext || !this.vipNext.name) return 0;
      const match = this.vipNext.name.match(/(\d+)/);
      if (!match) return 0;
      const lv = Number(match[1]);
      const found = this.levels.find((l) => l.level === lv);
      return found ? found.salary : 0;
    },
    allMet() {
      if (!this.vipNext || !this.vipNext.items) return false;
      return this.vipNext.items.every((item) => item.ok);
    },
    ascendTipText() {
      if (!this.vipNext) {
        return this.getLabel("vip.maxLevel", "You have reached the maximum VIP level");
      }
      return this.allMet
          ? this.getLabel("vip.tipReady", "Condition of Ascension: Meets all conditions to apply for the ascent")
          : this.getLabel("vip.tipPending", "Rise Condition: Complete all requirements to level up");
    },
  },
  mounted() {
    this.start();
  },
  methods: {
    getLabel(key, defaultText) {
      return this.$te(key) ? this.$t(key) : defaultText;
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatNum(value) {
      return Number(value || 0).toLocaleString("en-US");
    },
    isMoneyReq(key) {
      return key === "personal_recharge" || key === "team_recharge";
    },
    start() {
      Fetch("/user/info", {})
          .then((r) => {
            const d = (r && r.data) || {};
            const vip = d.vip || {};
            this.vipCurrent = vip.current || d.vip_name || "VIP0";
            this.vipSubRecharge = Number(vip.sub_recharge || 0);
            this.vipNext = vip.next || null;
          })
          .catch(() => {});
    },
    onRefresh() {
      this.start();
    },
    goSalaryHistory() {
      this.$router.push("/rechargeRecord");
    },
    onAscend() {
      if (this.ascendLoading) return;
      if (!this.vipNext) {
        this.$toast(this.getLabel("vip.maxLevel", "You have reached the maximum level"));
        return;
      }
      if (!this.allMet) {
        this.$toast(this.getLabel("vip.tipPending", "Rise Condition: Complete all requirements to level up"));
        return;
      }
      this.ascendLoading = true;
      Fetch("/user/vip_up", {})
          .then(() => {
            this.$toast.success(this.getLabel("vip.ascendSuccess", "Successfully submitted promotion request"));
            this.start();
          })
          .catch(() => {})
          .finally(() => {
            this.ascendLoading = false;
          });
    },
  },
};
</script>

<style lang="less" scoped>
.vip-page {
  min-height: 100vh;
  background: #05070f;
  color: #fff;
}

.top-nav {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  padding: 0 14px;
}

.icon-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid rgba(90, 130, 200, 0.3);
  border-radius: 50%;
  background: rgba(20, 35, 65, 0.6);
  color: #cdd8ee;
  display: grid;
  place-items: center;
  cursor: pointer;
}

.icon-btn:first-child { left: 0; }
.icon-btn:last-child { right: 0; }
.icon-btn .van-icon { font-size: 18px; }

.nav-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #eef3ff;
  display: flex;
  align-items: center;
  gap: 6px;
}

.crown-svg {
  width: 18px;
  height: 18px;
  color: #ffd25e;
}
.crown-svg.lg { width: 26px; height: 26px; }
.crown-svg.sm { width: 16px; height: 16px; }

.page-shell {
  width: 100%;
  max-width: 430px;
  min-height: 100vh;
  margin: 0 auto;
  padding: 0 14px 40px;
  box-sizing: border-box;
  background:
      radial-gradient(circle at 80% 0%, rgba(30, 120, 200, 0.12), transparent 45%),
      #05070f;
}

/* ---- Nivel Actual ---- */
.current-card {
  margin-bottom: 18px;
  padding: 16px;
  border-radius: 16px;
  background: linear-gradient(135deg, #2fd0e6, #17a2c4);
  color: #04222b;
  box-shadow: 0 6px 20px rgba(45, 190, 220, 0.3);
}

.current-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.current-label {
  font-size: 13px;
  font-weight: 500;
  opacity: 0.85;
}

.history-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border: 0;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.25);
  color: #04222b;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.current-level {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 24px;
  font-weight: 800;
}

.current-divider {
  height: 1px;
  margin: 12px 0;
  background: rgba(4, 34, 43, 0.25);
}

.current-sub {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
}

/* ---- Siguiente Nivel ---- */
.next-section {
  margin-bottom: 22px;
}

.next-title {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 700;
  color: #e6edfb;
}

.req-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 12px;
}

.req-item {
  padding: 12px;
  border: 1px solid rgba(70, 110, 190, 0.3);
  border-radius: 12px;
  background: rgba(12, 24, 46, 0.72);
}

.req-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 12px;
  color: #9fb0cc;
}

.req-head .mark { font-size: 14px; }
.mark.ok { color: #2fd0e6; }
.mark.no { color: #ff6b6b; }

.req-value {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

.req-value.cyan { color: #2fd0e6; }
.req-value .unit { font-size: 12px; font-weight: 500; color: #9fb0cc; }

/* ---- Salario Diario ---- */
.salary-card {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding: 14px 16px;
  border: 1px solid rgba(200, 160, 60, 0.35);
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(120, 90, 30, 0.55), rgba(60, 42, 12, 0.7));
}

.salary-icon {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #ffb020;
  color: #4a3000;
  display: grid;
  place-items: center;
}

.salary-icon .van-icon { font-size: 20px; }

.salary-mid { flex: 1; min-width: 0; }
.salary-label { font-size: 13px; color: #e6d9b8; margin-bottom: 2px; }
.salary-value { font-size: 18px; font-weight: 800; color: #ffd25e; }
.per-day { font-size: 12px; color: #9fb0cc; }

/* ---- Condición de Ascenso ---- */
.ascend-tip {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 14px;
  padding: 10px 12px;
  border: 1px solid rgba(45, 120, 220, 0.35);
  border-radius: 10px;
  background: rgba(20, 50, 100, 0.45);
  color: #9fc5ff;
  font-size: 12px;
  line-height: 1.5;
}

.ascend-tip .van-icon { flex-shrink: 0; margin-top: 2px; }

.ascend-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 48px;
  border: 1px solid rgba(70, 110, 190, 0.3);
  border-radius: 12px;
  background: rgba(12, 24, 46, 0.72);
  color: #9fb0cc;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}

.ascend-btn:disabled { opacity: 0.6; cursor: not-allowed; }

/* ---- Beneficios ---- */
.benefits-title {
  margin: 0 0 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  font-weight: 700;
  color: #e6edfb;
}

.level-card {
  margin-bottom: 14px;
  padding: 14px;
  border: 1px solid rgba(70, 110, 190, 0.3);
  border-radius: 14px;
  background: rgba(10, 20, 40, 0.6);
}

.level-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}

.level-head .mini-crown {
  margin-left: auto;
  color: #ffd25e;
  font-size: 18px;
}
</style>
